import script from "./TriadMetronome.vue?vue&type=script&setup=true&lang=js"
export * from "./TriadMetronome.vue?vue&type=script&setup=true&lang=js"

import "./TriadMetronome.vue?vue&type=style&index=0&id=89814cd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89814cd6"]])

export default __exports__